module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container mt-2"
  }, [_c('h3', [_vm._v("Demo VueJS component VueSlideoutPanel")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://github.com/lyollix/vue-slideout-panel"
    }
  }, [_vm._v("\n    View on github https://github.com/lyollix/vue-slideout-panel\n  ")]), _vm._v(" "), _c('hr'), _c('br'), _vm._v(" "), _c('div', [_c('h6', [_c('a', {
    attrs: {
      "href": "#demo1"
    },
    on: {
      "click": function($event) {
        _vm.d1.v = true
      }
    }
  }, [_vm._v("Demo 1 /Simple 1-section/")])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.d1.code))])]), _vm._v(" "), _c('div', [_c('h6', [_c('a', {
    attrs: {
      "href": "#demo2"
    },
    on: {
      "click": function($event) {
        _vm.d2.v = true
      }
    }
  }, [_vm._v("Demo 2 /Simple 2-sections/")])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.d2.code))])]), _vm._v(" "), _c('div', [_c('h6', [_c('a', {
    attrs: {
      "href": "#demo3"
    },
    on: {
      "click": function($event) {
        _vm.d3.v = true
      }
    }
  }, [_vm._v("Demo 3 /Customizing/")])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.d3.code))])]), _vm._v(" "), _c('div', [_c('h6', [_c('a', {
    attrs: {
      "href": "#demo4"
    },
    on: {
      "click": function($event) {
        _vm.d4.v = true
      }
    }
  }, [_vm._v("Demo 4 /Customizing/")])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.d4.code))])]), _vm._v(" "), _c('div', [_c('h6', [_c('a', {
    attrs: {
      "href": "#demo4"
    },
    on: {
      "click": function($event) {
        _vm.d5.v = true
      }
    }
  }, [_vm._v("Demo 5 /Customizing/")])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.d5.code))])]), _vm._v(" "), _c('div', [_c('h6', [_c('a', {
    attrs: {
      "href": "#demo5"
    },
    on: {
      "click": function($event) {
        _vm.d6.v = true
      }
    }
  }, [_vm._v("Demo 6 (+Demo 7) /Nested blocks/")])]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.d6.code))])]), _vm._v(" "), _c('vue-slideout-panel', {
    on: {
      "close": function($event) {
        _vm.d1.v = false
      }
    },
    model: {
      value: (_vm.d1.v),
      callback: function($$v) {
        _vm.d1.v = $$v
      },
      expression: "d1.v"
    }
  }, [_vm._v("\n       " + _vm._s(_vm.lorem) + "\n  ")]), _vm._v(" "), _c('vue-slideout-panel', {
    attrs: {
      "count": 2
    },
    on: {
      "close": function($event) {
        _vm.d2.v = false
      }
    },
    model: {
      value: (_vm.d2.v),
      callback: function($$v) {
        _vm.d2.v = $$v
      },
      expression: "d2.v"
    }
  }, [_vm._v("\n       " + _vm._s(_vm.lorem) + "\n       "), _c('div', {
    slot: "extra"
  }, [_vm._v(_vm._s(_vm.lorem))])]), _vm._v(" "), _c('vue-slideout-panel', {
    attrs: {
      "closeHtml": "<i class=\"ti-close\" aria-hidden=\"true\"></i>",
      "widths": ['30%'],
      "styles": _vm.d3.styles
    },
    on: {
      "close": function($event) {
        _vm.d3.v = false
      }
    },
    model: {
      value: (_vm.d3.v),
      callback: function($$v) {
        _vm.d3.v = $$v
      },
      expression: "d3.v"
    }
  }, [_vm._v("\n       " + _vm._s(_vm.lorem) + "\n  ")]), _vm._v(" "), _c('vue-slideout-panel', {
    attrs: {
      "count": 2,
      "showExtra": true,
      "widths": ['col-8', '60%'],
      "styles": [{
        padding: 0
      }, {
        padding: '1rem 1rem 4rem'
      }, {
        same: true
      }],
      "classes": ['', 'bg-success', 'same'],
      "closeHtml": "<button class='btn btn-success'>Закрыть</button>",
      "closeAllHtml": "<button class=\"btn btn-success\"><i class=\"ti-share-alt\" aria-hidden=\"true\"></i></button>",
      "extraHtml": "<button class='btn btn-success'><i class='ti-control-forward' aria-hidden='true'></i></button>"
    },
    on: {
      "close": function($event) {
        _vm.d4.v = false
      }
    },
    model: {
      value: (_vm.d4.v),
      callback: function($$v) {
        _vm.d4.v = $$v
      },
      expression: "d4.v"
    }
  }, [_vm._v("\n       " + _vm._s(_vm.lorem) + "\n       "), _c('div', {
    slot: "extra"
  }, [_vm._v(_vm._s(_vm.lorem))])]), _vm._v(" "), _c('vue-slideout-panel', {
    attrs: {
      "count": 2,
      "widths": ['col-8', '40%'],
      "styles": [{
        padding: 0
      }, {
        padding: '1rem 1rem 4rem'
      }, {
        same: true
      }],
      "classes": ['', 'bg-warning', 'bg-warning'],
      "closeHtml": "<button class='btn btn-warning'>Закрыть</button>",
      "closeAllHtml": "<button class='btn btn-warning'><i class='ti-share-alt' aria-hidden='true'></i></button>",
      "extraHtml": "<button class='btn btn-warning'><i class='ti-control-forward' aria-hidden='true'></i></button>"
    },
    on: {
      "close": function($event) {
        _vm.d5.v = false
      }
    },
    model: {
      value: (_vm.d5.v),
      callback: function($$v) {
        _vm.d5.v = $$v
      },
      expression: "d5.v"
    }
  }, [_vm._v("\n       " + _vm._s(_vm.lorem) + "\n       "), _c('div', {
    slot: "extra"
  }, [_vm._v(_vm._s(_vm.lorem))])]), _vm._v(" "), _c('vue-slideout-panel', {
    attrs: {
      "count": 2,
      "widths": ['70%', '70%']
    },
    on: {
      "close": function($event) {
        _vm.d6.v = false
      }
    },
    model: {
      value: (_vm.d6.v),
      callback: function($$v) {
        _vm.d6.v = $$v
      },
      expression: "d6.v"
    }
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.d7.v),
      expression: "d7.v"
    }],
    attrs: {
      "type": "checkbox",
      "id": "chb"
    },
    domProps: {
      "checked": Array.isArray(_vm.d7.v) ? _vm._i(_vm.d7.v, null) > -1 : (_vm.d7.v)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.d7.v,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.d7.v = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.d7.v = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.d7.v = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "chb"
    }
  }, [_vm._v("Demo 7")])]), _vm._v("\n\n       " + _vm._s(_vm.lorem) + "\n\n       "), _c('vue-slideout-panel', {
    attrs: {
      "widths": ['40%']
    },
    on: {
      "close": function($event) {
        _vm.d7.v = false
      }
    },
    model: {
      value: (_vm.d7.v),
      callback: function($$v) {
        _vm.d7.v = $$v
      },
      expression: "d7.v"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lorem) + "\n       ")]), _vm._v(" "), _c('div', {
    slot: "extra"
  }, [_vm._v(_vm._s(_vm.lorem))])], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer mt-2"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('p', {
    staticClass: "text-center"
  }, [_vm._v("© 2017 lyollix")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cb8a584"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 7
// module chunks = 1